import React, { useEffect, useRef, useState } from 'react';
import { CssBaseline, Grid } from '@material-ui/core';
import { Link, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
// Shared Components

import Spinner from '../components/Spinner/Spinner';
import Navbar from './layout/Navbar/navbar';
import Sidebar from './layout/Sidebar/sidebar';
// Pages

// Styles
import NewFlow from '../home/pages/automs/newFlow/NewFlow';
import AutomService from '../services/AutomService/AutomService';
import { useRecoilValue } from 'recoil';
import { licensePermission, rolePermission } from '../recoil-store/recoil-state';
import { useRecoilActions } from '../recoil-store/recoil-actions';
import './shared.css';

function SharedFlow() {
    const [loading, setLoading] = useState(true);
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const permissions = useRecoilValue(rolePermission);
    const license = useRecoilValue(licensePermission);
    const actions = useRecoilActions();
    const location = useLocation();
    const history = useNavigate();
    const data = useRef([]);

    useEffect(() => {
        fetchData().then(r => r);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchData = async () => {
        actions.connection();
        const startDate = '2020-01-15T21:00:00.000Z';
        const endDate = '3023-01-23T15:00:00.000Z';
        const res = await AutomService.getAutomCount(startDate, endDate);

        if (res?.status === 'fail') {
            history('/login?to=' + location.pathname);
        } else {
            // Find active automs
            if (res?.status && res.data) {
                data.current = res.data.count;
            }
            await actions.getLicensePermission();
            await actions.getPersonalization();
            await actions.getRolePermission();
        }
        setLoading(false);
    }

    return (
        <div>
            <CssBaseline />
            {loading ?
                <div className="loading-container"><Spinner /></div> :
                permissions?.status ? (
                    <div id="shared-container" className="flow-page">
                        <Sidebar id="sidebar-flow" sideBarOpen={sideBarOpen} setSideBarOpen={setSideBarOpen} />
                        <Grid container id="home-container-flow">
                            <Routes>
                                {/* {permissions?.data?.includes('CUSTOMAUTOMS_VIEW') && license?.data?.no_of_rpa_bots >= data?.current.length ?
                                    <Route  path='/autom/edit' element={<FlowConfiguration/>}/> :
                                        <Route path="/automs" element={<Navigate to="/automs"/>}/>}
                                    {permissions?.data?.includes('CUSTOMAUTOMS_VIEW') && license?.data?.no_of_rpa_bots >= data?.current.length ?
                                        <Route  path='/process/edit' element={<ProcessConfiguration/>}/> :
                                        <Route path="/automs" element={<Navigate to="/automs"/>}/> } */}
                                {permissions?.data?.includes('CUSTOMAUTOMS_VIEW') && license?.data?.no_of_rpa_bots >= data?.current ?
                                    <Route path='/autom/edit' element={<NewFlow />} /> :
                                    <Route path="/automs" element={<Navigate to="/automs" />} />}
                                {permissions?.data?.includes('CUSTOMAUTOMS_VIEW') && license?.data?.no_of_rpa_bots >= data?.current ?
                                    <Route path='/process/edit' element={<NewFlow />} /> :
                                    <Route path="/automs" element={<Navigate to="/automs" />} />}
                                <Route path="*" element={<Navigate to="/404" />} />
                            </Routes>
                        </Grid>
                        <div id="myModal" className="modal">
                            <span className="close" onClick={function () {
                                let modal = document.getElementById("myModal");
                                modal.style.display = "none";
                            }}>&times;</span>
                            <img className="modal-content" id="img01" alt="autommate" />
                            <div id="caption" />
                        </div>
                    </div>
                )
                    :
                    (<div className="loading-container">
                        <Navigate to={`/login?to=${location.pathname}`} />
                        Permissions Not Found
                        <Link to="/login">
                            Back to Login
                        </Link>
                    </div>)
            }
        </div>
    );
}

export default SharedFlow;
